import { api } from "./base";

export const getHomeData = async ({locale}) => {
    api.defaults.headers = {locale};
    const res = await api.get('/home');
    return res.data;
}